"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsColorShadeKey_1 = __importDefault(require("./valueIsColorShadeKey"));
const valueIsControlsColoSpecificationBase_1 = __importDefault(require("./valueIsControlsColoSpecificationBase"));
const valueIsControlsColorDefinition = (0, ts_validators_1.buildValueIsShape)('ColorDefinition', {
    alpha: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsNumber,
    ]),
    base: valueIsControlsColoSpecificationBase_1.default,
    shade: (0, ts_validators_1.buildValueIsOneOf)([
        valueIsColorShadeKey_1.default,
        (0, ts_validators_1.buildValueIsConstant)(50),
        (0, ts_validators_1.buildValueIsConstant)(100),
        (0, ts_validators_1.buildValueIsConstant)(200),
        (0, ts_validators_1.buildValueIsConstant)(300),
        (0, ts_validators_1.buildValueIsConstant)(400),
        (0, ts_validators_1.buildValueIsConstant)(500),
        (0, ts_validators_1.buildValueIsConstant)(600),
        (0, ts_validators_1.buildValueIsConstant)(700),
        (0, ts_validators_1.buildValueIsConstant)(800),
        (0, ts_validators_1.buildValueIsConstant)(900),
    ]),
});
exports.default = valueIsControlsColorDefinition;
